var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { alias } from '@ember/object/computed';
import { fragment } from 'ember-data-model-fragments/attributes';
import { CATALOG_DISCOUNT_TYPE } from '@square/dashboard-items-data/models/connect/discount/data';
const MAXIMUM_FRACTION_DIGITS = 2;
let Discount = (_dec = attr('string', {
  protoEnum: CatalogObjectTypeProto,
  defaultValue: CatalogObjectType.DISCOUNT
}), _dec2 = fragment('connect/discount/data'), _dec3 = alias('discountData.name'), _dec4 = alias('discountData.discountType'), _dec5 = alias('discountData.percentage'), _dec6 = alias('discountData.amountMoney'), _dec7 = computed('discountType'), _dec8 = computed('discountType'), _dec9 = computed('amountMoney.{amount,currency}', 'discountType', 'percentage', 'userInfo.currencyCode'), _class = (_class2 = class Discount extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "type", _descriptor4, this);
    _initializerDefineProperty(this, "discountData", _descriptor5, this);
    _initializerDefineProperty(this, "name", _descriptor6, this);
    _initializerDefineProperty(this, "discountType", _descriptor7, this);
    _initializerDefineProperty(this, "percentage", _descriptor8, this);
    _initializerDefineProperty(this, "amountMoney", _descriptor9, this);
  }
  get isPercentage() {
    return this.discountType === CATALOG_DISCOUNT_TYPE.FIXED_PERCENTAGE || this.discountType === CATALOG_DISCOUNT_TYPE.VARIABLE_PERCENTAGE;
  }
  get isVariable() {
    return this.discountType === CATALOG_DISCOUNT_TYPE.VARIABLE_AMOUNT || this.discountType === CATALOG_DISCOUNT_TYPE.VARIABLE_PERCENTAGE;
  }
  get discountText() {
    switch (this.discountType) {
      case CATALOG_DISCOUNT_TYPE.VARIABLE_AMOUNT:
        {
          let currencyCode = this.amountMoney?.currency;
          if (isNone(currencyCode)) {
            currencyCode = this.userInfo.currencyCode;
          }
          const currencyFormatter = this.formatter.getCurrencyFormatter(currencyCode, false);
          return this.intl.t('items.discounts.variablePriceLabel', {
            currencySymbol: currencyFormatter.currencySymbol()
          });
        }
      case CATALOG_DISCOUNT_TYPE.VARIABLE_PERCENTAGE:
        return this.intl.t('items.discounts.variablePercentageLabel');
      case CATALOG_DISCOUNT_TYPE.FIXED_AMOUNT:
        return this.formatter.currency(this.amountMoney.amount, this.amountMoney.currency, {
          maximumFractionDigits: MAXIMUM_FRACTION_DIGITS
        });
      case CATALOG_DISCOUNT_TYPE.FIXED_PERCENTAGE:
        return this.formatter.percent(Number(this.percentage), {
          maximumFractionDigits: MAXIMUM_FRACTION_DIGITS
        });
      default:
        return '';
    }
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/discount'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "discountData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "discountType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "percentage", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "amountMoney", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isPercentage", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "isPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isVariable", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "isVariable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "discountText", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "discountText"), _class.prototype), _class);
export { Discount as default };